import {useEffect} from 'react'
import {Button, Card, Col, Row} from "antd";
import bloxImg from "../../../assets/thumbnail/bloxshut.png";
import {Link} from "react-router-dom";
import psxImg from "../../../assets/thumbnail/psx.png";
import React from "react";
import {useStore} from "../../../state/storeHooks";

const DashboardIndex: React.FC = () => {

    const {user} = useStore(({app}) => app);

    const {access} = user.unwrap();

    const decodeAccess = JSON.parse(access);

    const checkAccess = (accessVal: string) => {
        return decodeAccess.find((element: any) => element === accessVal) !== undefined
    }
    
    useEffect(() => {
        document.title = 'Chimovo - Dashboard'
    }, []);

    return(
        <div style={{color: "white", marginTop: 12}}>
            <Row gutter={[16, 16]}>
                <Col>
                    <Card title="Blox Fruit"
                          hoverable
                          cover={<img style={{width: "100%"}} alt="example" src={bloxImg}/>}
                    >
                        <Link to={"blox-fruit/tracking"}>
                            <Button style={{width: "100%"}} type={"default"}> Blox Fruit </Button>
                        </Link>
                    </Card>
                </Col>
                <Col>
                    <Card title="Pet Simulator X"
                          hoverable
                          cover={<img alt="example" src={psxImg}/>}
                    >
                        <Link to={"petx"}>
                            <Button style={{width: "100%"}} type={"default"}> Pet Simulator
                                X </Button>
                        </Link>
                    </Card>
                </Col>

                {
                    checkAccess("pet99") ?
                        <Col>
                            <Card title="Pet Simulator 99"
                                  hoverable
                                  cover={<img alt="example" src={psxImg}/>}
                            >
                                <Link to={"pet99/tracking"}>
                                    <Button style={{width: "100%"}} type={"default"}> Pet Simulator
                                        99 </Button>
                                </Link>
                            </Card>
                        </Col> :
                        <></>
                }

                {
                    /*
                    whitelistAccounts.find((element) => element == username) != undefined ?
                        <Col>
                            <Card title="Blade Ball"
                                  hoverable
                                  cover={<assets style={{width: 225}} alt="example" src={bladeballImg}/>}
                            >
                                <Link to={"bladeball"}>
                                    <Button style={{width: "100%"}} type={"default"}> Blade Ball </Button>
                                </Link>
                            </Card>
                        </Col>
                        : <></>
                     */
                }
            </Row>
        </div>
    )
}

export default DashboardIndex